export default __webpack_public_path__ + "static/media/nft22.eb481c4f.png";